module.exports = __webpack_public_path__ + "static/media/izlozba (22).349631a0.jpg";